import { EXCLUDED_FQDN_RU } from '@/constants/excludedNodeFromTree';
import { store } from '@/main';
import { TreeData } from '@/templates/Tree';

export const excludeNodeByFqdn = (tree: TreeData[], fqdnToExclude: string): TreeData[] => {
  const fqdnDotNotation = fqdnToExclude.replace(/\//g, '.');

  const recursivelyExclude = (nodes: TreeData[]): TreeData[] =>
    nodes
      .filter((node) => node.fqdn !== fqdnDotNotation)
      .map((node) => ({
        ...node,
        ...(node.children ? { children: recursivelyExclude(node.children) } : {}),
      }));

  return recursivelyExclude(tree);
};

export const excludeNodes = (tree: TreeData[]): TreeData[] => {
  if (store.getters.getCountryCode && store.getters.getCountryCode !== 'ru') {
    return tree;
  }

  return excludeNodeByFqdn(tree, EXCLUDED_FQDN_RU);
};
